import {
    createStyles,
    Menu,
    Center,
    Header,
    Container,
    Group,
    Button,
    rem,
    Anchor,
    Text
} from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
// import { navLinks } from '../../data/pageLinks';

const HEADER_HEIGHT = rem(60);

const useStyles = createStyles((theme) => ({
    inner: {
        height: HEADER_HEIGHT,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },

    links: {
        [theme.fn.smallerThan('sm')]: {
            display: 'none',
        },
    },

    burger: {
        [theme.fn.largerThan('sm')]: {
            display: 'none',
        },
    },

    link: {
        display: 'block',
        lineHeight: 1,
        padding: `${rem(8)} ${rem(12)}`,
        borderRadius: theme.radius.sm,
        textDecoration: 'none',
        color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[7],
        fontSize: theme.fontSizes.sm,
        fontWeight: 500,

        '&:hover': {
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
        },
    },

    linkLabel: {
        marginRight: rem(5),
    },
}));

interface HeaderActionProps {
    links: { link: string; label: string; links?: { link: string; label: string }[] }[];
}

export function HeaderAction({ links }: HeaderActionProps) {
    const { classes } = useStyles();
    const items = links.map((link) => {
        const menuItems = link.links?.map((item) => (
            <Menu.Item key={item.link}>{item.label}</Menu.Item>
        ));

        if (menuItems) {
            return (
                <Menu key={link.label} trigger="hover" transitionProps={{ exitDuration: 0 }} withinPortal>
                    <Menu.Target>
                        <a
                            href={link.link}
                            className={classes.link}
                            onClick={(event) => event.preventDefault()}
                        >
                            <Center>
                                <span className={classes.linkLabel}>{link.label}</span>
                                <IconChevronDown size={rem(12)} stroke={1.5} />
                            </Center>
                        </a>
                    </Menu.Target>
                    <Menu.Dropdown>{menuItems}</Menu.Dropdown>
                </Menu>
            );
        }

        return (
            <a
                key={link.label}
                href={link.link}
                className={classes.link}
                onClick={(event) => event.preventDefault()}
            >
                {link.label}
            </a>
        );
    });

    return (
        <Header height={HEADER_HEIGHT} sx={{ borderBottom: 0 }} mb={120} id="top">
            <Container className={classes.inner} fluid>
                <Group>
                    <Anchor component={Link} to={`/`}>
                        <Text
                            component="span"
                            align="center"
                            variant="gradient"
                            gradient={{ from: "indigo", to: "cyan", deg: 45 }}
                            size="xl"
                            weight={800}
                        >
                            PriceToRent
                        </Text>
                    </Anchor>
                </Group>
                <Group spacing={5} className={classes.links}>
                    {items}
                </Group>
                <Button radius="xl" h={30}
                    component={Link}
                    to="/dashboard"
                >
                    Get Started
                </Button>
            </Container>
        </Header>
    );
}

// const headerLinks = {
//     links: [
//         navLinks["Home"],
//         navLinks["Dashboard"],
//         {
//             link: "#1",
//             label: "Legal",
//             links: [
//                 navLinks["Privacy"],
//                 navLinks["Terms"],
//             ],
//         }

//     ],
// };

export function HeaderPopulated() {
    // return <HeaderAction links={headerLinks.links} />;
    return <HeaderAction links={[]} />;
}